<template>
  <div>
    <h1 class="applicationNav">
      <span>特种设备检验检测机构核准证查询</span>
    </h1>
    <section class="query-container">
      <el-form action="" :model="formData" ref="formData" :rules="formRules">
        <!-- <el-form-item label="社会信用代码" prop="num">
          <el-input
            placeholder="请输入社会信用代码"
            prefix-icon="el-icon-document"
            v-model="formData.num"
          >
          </el-input>
        </el-form-item> -->
        <!-- <el-form-item label="性别" prop="sex">
          <el-checkbox-group v-model="formData.sex">
            <el-checkbox label="1" name="sex">男</el-checkbox>
            <el-checkbox label="2" name="sex">女</el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item label="公司名称" prop="name">
          <el-input
            placeholder="请输入公司名称"
            prefix-icon="el-icon-document"
            clearable
            v-model="formData.name"
          >
          </el-input>
        </el-form-item>
        <div class="verification-code clearfix">
          <el-form-item label="验证码" prop="code" :rules="formRules.code">
            <el-input
              placeholder="请输入验证码"
              prefix-icon="el-icon-edit"
              v-model="formData.code"
            >
            </el-input>
          </el-form-item>
          <div class="code" @click="updateCode">
            <canvas id="canvas" width="100" height="45"></canvas>
          </div>
        </div>
        <div class="form-btn clearfix">
          <input
            type="button"
            class="submit"
            value="立即查询"
            @click="validateForm('formData')"
          />
          <input
            type="reset"
            @click="resetForm('formData')"
            value="重置信息"
            class="reset"
          />
        </div>
      </el-form>
    </section>
    <section class="result-container" v-if="isOpenResultContaniner">
      <h1 class="applicationNav">
        <span>查询结果</span>
      </h1>
      <div class="results" v-if="isOpenResult">
        <table v-for="(item, index) in results" :key="index" class="result-box">
          <tr>
            <td>企业名称</td>
            <td>{{ item.entname || "暂无数据" }}</td>
            <td>信用代码</td>
            <td>{{ item.uniscid || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>注册号</td>
            <td>{{ item.regno || "暂无数据" }}</td>
            <td>法定代表人</td>
            <td>{{ item.name || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>文件编号</td>
            <td>{{ item.licno || "暂无数据" }}</td>
            <td>文件名称</td>
            <td>{{ item.licname_cn || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>有效期自</td>
            <td>{{ arrDate(item.valiperifrom) || "暂无数据" }}</td>
            <td>有效期止</td>
            <td>{{ arrDate(item.valiperito) || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>许可机关</td>
            <td colspan="3">{{ item.licanth || "暂无数据" }}</td>
           
          </tr>
          <!-- <tr>
            <td>本次拟购买情况规格</td>
            <td>{{ item.spec || "暂无数据" }}</td>
            <td>供应单位</td>
            <td>{{ item.nameSupplier || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>邮编</td>
            <td>{{ item.post || "暂无数据" }}</td>
            <td>供应单位法定代表人</td>
            <td>{{ item.legalPerson || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>本次拟购买情况名称</td>
            <td>{{ item.drugName || "暂无数据" }}</td>
            <td>电话</td>
            <td>{{item.tel || "暂无数据" }}</td>
          </tr>
          <tr>
            <td>发证机关</td>
            <td>{{ item.acceptOffice || "暂无数据" }}</td>
            <td>本次拟购买情况数量</td>
            <td>{{ item.drugNum || "暂无数据" }}</td>
          </tr> -->
        </table>
        <div class="block">
          <el-pagination
            background
            @current-change="currentChange"
            :current-page="pageNo"
            :page-size="10"
            prev-text="上一页"
            next-text="下一页"
            :hide-on-single-page="true"
            layout="total, prev, pager, next"
            :total="count"
          >
          </el-pagination>
        </div>
        <!-- <div class="tips">注：查询结果仅为甘肃省常住人口</div> -->
      </div>
      <div class="no-results" v-else>
        <img src="../assets/img/zwjl.png" alt="" />
        <p>{{ info }}</p>
      </div>
    </section>
  </div>
</template>
<script>
import { createCode, validateCode } from "@/utils/checkCode";
import req from "@/utils/request";
import sm2 from "@/utils/sm2";
import md5 from "md5";

export default {
  name: "IndexView",
  created() {},
  mounted() {
    createCode();
  },
  data() {
    const checkCode = (rule, value, callback) => {
      if (!validateCode(value.toLowerCase())) {
        this.formData.code = "";
        return callback(new Error("验证码错误"));
      }
      callback();
    };

    return {
      info: "",
      isOpenResultContaniner: false,
      isOpenResult: false,
      formData: {
        num: "",
        name: "",
        code: "",
      },
      form: {},
      pageNo: 1,
      count: "",
      results: [],
      formRules: {
        name: [
          {
            required: true,
            message: "公司名称不能为空",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "验证码不能为空", trigger: "focus" },
          { min: 4, max: 4, message: "验证码长度为4个字符", trigger: "focus" },
          { validator: checkCode, trigger: "focus" },
        ],
      },
    };
  },
  methods: {
    //通用脱敏方法 参数1：需脱敏字段  参数2：前面需要展示几个字符  参数3：后面需要展示几个字符（后面需要1个则为-1）
    currentChange(pageNum) {
      this.pageNo = pageNum;
      // 根据新的页码重新请求
      this.getData(this.params);
    },
    desensitization(str, beginLen, endLen) {
      let len = str.length;
      let firstStr = str.substr(0, beginLen);
      let lastStr = endLen ? str.substr(endLen) : "";
      let middleStr = str
        .substring(beginLen, len - Math.abs(endLen))
        .replace(/[\s\S]/gi, "*");
      return firstStr + middleStr + lastStr;
    },
    //姓名脱敏
    desensitizationName(str) {
      let len = str > 2 ? -2 : -1;
      return this.desensitization(str, 0, len);
    },
    //地址脱敏
    desensitizationAddress(str) {
      let len;
      if (str.includes("区")) {
        len = str.indexOf("区") + 1;
      } else if (str.includes("县")) {
        len = str.indexOf("县") + 1;
      }
      return this.desensitization(str, len, 0);
    },
    //时间戳转日期
    transferDate(str) {
      let date = new Date(str); // 参数需要毫秒数，所以这里将秒数乘于 1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      return Y + M + D;
    },
    //数组转日期
    arrDate(arr) {
      let date = arr;
      let Y = date[0];
      let M = date[1];
      let D = date[2];
      return Y + "-" + M + "-" + D;
    },
    updateCode() {
      createCode();
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        createCode();
        if (valid) {
          // this.form.name = this.formData.name;
          this.pageNo = 1;
          this.getData();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.isOpenResult = false;
      this.isOpenResultContaniner = false;
      createCode();
    },
    async getData() {
      window.openModel();
      const time = new Date().valueOf();
      const params = {
        header: "{}",
        raw: JSON.stringify({
          type: sm2.encrypt("elicncertificatetezhongshebei"),
          data: sm2.encrypt("qzk"),
          searchKey: sm2.encrypt(
            JSON.stringify([
              {
                key: "entname",
                value: this.formData.name,
                type: "like",
              },
            ])
          ),
          pageSize: 10,
          pageNo: this.pageNo,
        }),
        from: "1",
        key: "871440e079df476b8ee1c627d928047e",
        requestTime: time,
        sign: md5("gssjtsj" + time),
      };
      let res;
      try {
        res = await req.getData(params);
      } catch (e) {
        window.closeModel();
        window.openAlert("网络错误，请重试");
        return;
      }
      window.closeModel();
      this.isOpenResultContaniner = true;
      if (res.code == "200") {
        let response = JSON.parse(sm2.decrypt(res.data));
        console.log(response);
        this.results = response.infoList;
        this.count = response.count;
        if (response.count > 0 && this.results.length > 0) {
          this.isOpenResult = true;
        } else {
          this.isOpenResult = false;
          this.info = "查询无结果";
        }
      } else {
        window.openAlert("网络错误，请重试");
      }
    },
    currentChange(val) {
      this.pageNo = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.el-pagination.is-background .el-pager li:not(.disabled) {
  background-color: #fff;
  color: #fff;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgb(219, 0, 19);
  color: #fff;
}
</style>
